import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background-50 font-['Poppins']">
      {/* Top Navigation Bar */}
      <header className="bg-white border-b border-background-200/70">
        <nav className="px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold text-foreground-950">
                <span className="text-primary-500">Suncore</span> International
              </h1>
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line"></i>
              </div>
              Back to Home
            </Link>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main>
        {/* Hero Banner */}
        <section className="bg-background-100 py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Privacy Policy
            </h2>
            <p className="text-base text-foreground-600">
              Effective Date: 17 February 2026
            </p>
          </div>
        </section>

        {/* Policy Content */}
        <section className="py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="space-y-10 text-foreground-700 leading-relaxed">

              {/* Section 1 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">1. Introduction</h3>
                <p>
                  Suncore International FZE (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) respects your privacy and is committed to protecting any personal information you share with us. This Privacy Policy explains what data we collect through our Website (suncorefze.com), how we use it, and your rights regarding that data.
                </p>
              </div>

              {/* Section 2 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">2. Information We Collect</h3>
                <p className="mb-3">
                  We do not require user accounts, logins, or online payments on our Website. The personal information we may collect is limited to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <strong className="text-foreground-950">Contact Form Submissions:</strong> Your name, email address, phone number, company name, and any message you submit through the contact form on suncorefze.com. These submissions are sent to our email at suncore-uae.com.
                  </li>
                  <li>
                    <strong className="text-foreground-950">WhatsApp Inquiries:</strong> If you contact us via the WhatsApp link on our Website (+971 55 220 1127), we may receive your phone number, name, and message content as provided through the WhatsApp platform.
                  </li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">3. How We Use Your Information</h3>
                <p className="mb-3">We use the information collected solely for the following purposes:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>To respond to your product inquiries and quotation requests</li>
                  <li>To communicate with you regarding orders, deliveries, or support</li>
                  <li>To improve our services and customer experience</li>
                </ul>
                <p className="mt-3">
                  We do not use your personal data for automated decision-making, profiling, or marketing purposes unless you have given explicit consent.
                </p>
              </div>

              {/* Section 4 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">4. Data Sharing</h3>
                <p className="mb-3">
                  We do not sell, rent, or trade your personal information to any third parties. Your data may be shared only in the following limited circumstances:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>With trusted internal teams for the purpose of fulfilling your inquiry</li>
                  <li>Where required by law, regulation, or order of a competent authority</li>
                </ul>
              </div>

              {/* Section 5 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">5. Data Storage & Security</h3>
                <p>
                  Your personal data submitted through the contact form is received and stored on our email systems hosted under the suncore-uae.com domain. WhatsApp data is processed through Meta&rsquo;s WhatsApp Business platform. We take reasonable measures to protect your data, but no method of electronic transmission or storage is 100% secure.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">6. Cookies & Tracking</h3>
                <p>
                  Our Website does not currently use cookies or third-party tracking/analytics tools. Should this change in the future, this Privacy Policy will be updated accordingly, and appropriate consent mechanisms will be implemented.
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">7. Your Rights</h3>
                <p className="mb-3">Depending on applicable laws and regulations, you may have the right to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Request access to the personal data we hold about you</li>
                  <li>Request correction or deletion of your personal data</li>
                  <li>Withdraw consent where processing is based on consent</li>
                </ul>
                <p className="mt-3">
                  To exercise any of these rights, please contact us using the details provided below.
                </p>
              </div>

              {/* Section 8 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">8. Children&rsquo;s Privacy</h3>
                <p>
                  This Website is not intended for individuals under the age of 18. We do not knowingly collect personal data from minors. If you believe a minor has submitted personal information to us, please contact us so we can promptly delete it.
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">9. Changes to This Policy</h3>
                <p>
                  We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.
                </p>
              </div>

              {/* Section 10 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">10. Governing Law</h3>
                <p>
                  This Privacy Policy is governed by the rules and regulations of the Jebel Ali Free Zone Authority (JAFZA) and, where applicable, the federal laws of the United Arab Emirates.
                </p>
              </div>

              {/* Section 11 */}
              <div>
                <h3 className="text-xl font-semibold text-foreground-950 mb-3">11. Contact Us</h3>
                <p className="mb-4">
                  If you have any questions or concerns about this Privacy Policy, please reach out to us:
                </p>
                <div className="bg-background-100 rounded-lg p-6 space-y-2 text-sm">
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-mail-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">Email:</strong>{' '}
                      <a href="mailto:sales2@suncore-uae.com" className="text-primary-500 hover:text-primary-600 transition-colors">
                        sales2@suncore-uae.com
                      </a>
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-phone-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">Phone:</strong> +971 55 220 1127 / 04 261 5620
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-whatsapp-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">WhatsApp:</strong> +971 55 220 1127
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500 shrink-0 mt-0.5">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <span>
                      <strong className="text-foreground-950">Address:</strong> Warehouse TB03, Jebel Ali Free Zone, Dubai, UAE
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-foreground-950 text-white py-8">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <p className="text-sm text-white/70">
            &copy; 2025 Suncore International FZE. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}